import {
  checkSecurityPolicyWasUpdatedWithErrors,
} from './securityPolicy.adapters';
import {
  GET_SECURITY_POLICY_PENDING,
  GET_SECURITY_POLICY_FULFILLED,
  UPDATE_ERRORS,
  SecurityPolicyActionTypes,
  SecurityPolicyState,
} from './securityPolicy.types';

const initialState: SecurityPolicyState = {
  entities: [],
  errors: { securityPolicy: '' },
  ui: {
    isLoading: false,
    wasSecurityPolicyUpdatedWithErrors: false,
  }
};

export default function securityPolicyReducer(
  state = initialState,
  action: SecurityPolicyActionTypes,
): SecurityPolicyState {
  switch (action.type) {
    case GET_SECURITY_POLICY_PENDING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: true
        }
      };

    case GET_SECURITY_POLICY_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data || [],
        ui: {
          ...state.ui,
          isLoading: false
        }
      };

    case UPDATE_ERRORS:
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          wasSecurityPolicyUpdatedWithErrors: checkSecurityPolicyWasUpdatedWithErrors(action.payload)
        }
      };

    default:
      return state;
  }
}
